import axios from 'axios';
import tools from '@/composables/tools';
import type { InformeDetail, InformeFilter, PaginatedInformes } from '@/interfaces/Informe';

export abstract class InformeService {
  static async list(filter?: InformeFilter): Promise<PaginatedInformes | null> {
    try {
      const response = await axios.get('informes', { params: filter });
      return response.data;
    } catch (error) {
      console.error('InformeService.list', error);
      tools().toast('No se pudieron cargar los informes', 'danger', 3000);
      return null;
    }
  }

  static async atencionCount(): Promise<number> {
    try {
      const response = await axios.get('informes/atencion-count');
      return Number(response.data?.count ?? 0);
    } catch (error) {
      console.error('InformeService.atencionCount', error);
      return 0;
    }
  }

  static async getById(id: number): Promise<InformeDetail | null> {
    try {
      const response = await axios.get(`informes/${id}`);
      return response.data;
    } catch (error) {
      console.error('InformeService.getById', error);
      tools().toast('No se pudo cargar el informe', 'danger', 3000);
      return null;
    }
  }

  static async marcarLeido(id: number): Promise<boolean> {
    try {
      await axios.post(`informes/${id}/leer`);
      return true;
    } catch (error) {
      console.error('InformeService.marcarLeido', error);
      return false;
    }
  }
}
